export default class Timer {
	_now = null;
	_t0 = null;
	_t = null;
	_dt = null;
	_deferReset = false;

	constructor(now = null) {
		this._now = now || (() => window.performance.now() / 1000);
		this.deferReset();
	}

	reset() {
		this._t0 = this._now();
		this._t = this.t0;
		this._dt = 0;
		this._deferReset = false;
	}

	deferReset() {
		this._deferReset = true;
	}

	tick() {
		if (this._deferReset) {
			this.reset();
		}
		const tn = this._now();
		this._dt = tn - this._t;
		this._t = tn;
	}

	getDelta() {
		return this._dt;
	}

	get() {
		return this._t - this._t0;
	}

}
